
import { combineReducers } from 'redux';

import sign from './sign';
import error from './error';
export default combineReducers({
	sign,
	error
});